export const languages = ['en-US', 'es-ES'];
export const defaultLanguage = languages[0];
